<div class="min-h-screen bg-gray-50">
  <div class="w-full px-4 py-8">
    <div class="max-w-[95rem] mx-auto">
      <div class="grid grid-cols-1 xl:grid-cols-10 2xl:grid-cols-10 gap-6">
        <!-- Main Content -->
        <div class="xl:col-span-7 2xl:col-span-7 space-y-6">
          <!-- Product Search Card -->
          <div class="bg-white rounded-xl border border-gray-100 p-6 shadow-sm">
            <div class="mb-6">
              <h2 class="text-xl font-semibold text-gray-900 mb-2">Ajouter des Produits</h2>
              <p class="text-gray-600 text-sm">Recherchez des produits ou scannez un code-barres pour ajouter à votre
                commande</p>
            </div>

            <div class="relative" #barcodeInput>
              <!-- Visible search input -->
              <div class="relative">
                <i class="fa fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"></i>
                <input #searchInput type="text" autocomplete="off"
                  class="w-full h-10 pl-9 pr-4 border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all duration-200 text-gray-900 placeholder-gray-400 text-sm"
                  placeholder="Rechercher des produits par nom, description ou scanner un code-barres..."
                  [(ngModel)]="searchTerm" (input)="onInputChange($event)" (focus)="onSearchFocus()" />
              </div>

              <!-- Dropdown -->
              <div *ngIf="showDropdown"
                class="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-64 overflow-y-auto">
                <div *ngIf="isLoadingProducts" class="p-3 text-center">
                  <div class="inline-flex items-center gap-2">
                    <div class="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                    <span class="text-gray-600 text-sm">Recherche en cours...</span>
                  </div>
                </div>
                <ng-container *ngIf="!isLoadingProducts">
                  <ng-container *ngIf="productsToDisplay.length > 0; else noProducts">
                    <div class="py-1">
                      <button *ngFor="let product of productsToDisplay" type="button"
                        class="w-full p-3 text-left hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100 last:border-b-0"
                        (click)="addOrderLine(product)">
                        <div class="flex items-center justify-between">
                          <div class="flex-1 min-w-0">
                            <h3 class="font-medium text-gray-900 text-sm truncate">{{ product.name }}</h3>
                            <p *ngIf="product.description" class="text-xs text-gray-500 mt-0.5 truncate">{{
                              product.description }}</p>
                            <div class="flex items-center gap-2 mt-1.5">
                              <span class="px-2 py-0.5 bg-green-50 text-green-700 text-xs font-medium rounded">
                                {{ product.price | number:'1.2-2' }} MAD
                              </span>
                              <span class="px-2 py-0.5 bg-blue-50 text-blue-700 text-xs font-medium rounded">
                                Stock: {{ product.quantity }}
                              </span>
                              <span *ngIf="product.codeBare" class="text-xs text-gray-400 font-mono">#{{
                                product.codeBare }}</span>
                            </div>
                          </div>
                          <div class="flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full">
                            <i class="fa fa-plus text-blue-600 text-xs"></i>
                          </div>
                        </div>
                      </button>
                    </div>
                  </ng-container>
                  <ng-template #noProducts>
                    <div class="p-6 text-center">
                      <i class="fa fa-box-open text-2xl text-gray-300 mx-auto mb-2"></i>
                      <p class="text-gray-600 text-sm">Aucun produit trouvé</p>
                      <p class="text-xs text-gray-500 mt-1">Essayez un autre terme de recherche</p>
                    </div>
                  </ng-template>
                </ng-container>
              </div>
            </div>
          </div>

          <!-- Order Lines -->
          <div class="space-y-4">
            <ng-container *ngIf="newOrder.orderLines?.length; else emptyOrderState">
              <div *ngFor="let orderLine of newOrder.orderLines; let i = index"
                class="relative bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200">
                <!-- Top Part - Product Information -->
                <div class="p-4 border-b border-gray-100">
                  <div class="flex items-center justify-between">
                    <div class="flex-1 min-w-0">
                      <div class="flex flex-col">
                        <h3 class="font-bold text-gray-900 text-xl leading-tight mb-0">{{ orderLine.product?.name }}</h3>
                        <p *ngIf="orderLine.product?.description" class="text-gray-500 text-xs italic mb-2 tracking-tight opacity-75">{{
                          orderLine.product?.description }}</p>
                        
                        <div class="flex items-center flex-wrap gap-2">
                           <!-- Identifier Badge -->
                           <span *ngIf="orderLine.product?.codeBare" 
                                 class="text-[10px] font-mono font-bold text-indigo-700 bg-indigo-50 px-2 py-0.5 rounded border border-indigo-100 shadow-sm">
                             #{{ orderLine.product?.codeBare }}
                           </span>

                           <!-- Status Badges -->
                           <span class="text-[10px] font-bold text-emerald-800 bg-emerald-100 px-2 py-0.5 rounded-full border border-emerald-200 shadow-sm uppercase tracking-wider">
                             Stock: {{ orderLine.product?.quantity }}
                           </span>

                           <span *ngIf="(orderLine.returnedQuantity || 0) > 0"
                                 class="text-[10px] font-bold text-rose-700 bg-rose-50 px-2 py-0.5 rounded-full border border-rose-200 shadow-sm uppercase tracking-wider">
                             -{{ orderLine.returnedQuantity }} Retourné
                           </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Delete Button -->
                  <button (click)="openDeleteConfirmation(i)"
                    class="absolute top-3 right-3 w-8 h-8 flex items-center justify-center text-red-500 hover:text-red-600 hover:bg-red-50 rounded-full transition-all duration-200"
                    title="Supprimer l'article">
                    <i class="fa fa-times"></i>
                  </button>
                </div>

                <!-- Bottom Part - Controls -->
                <div class="p-4 bg-white border-t border-gray-100">
                  <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
                    <!-- Price Control -->
                    <div>
                      <label class="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2">Prix
                        Unitaire</label>
                      <div class="relative flex items-center">
                        <input type="text" autocomplete="off" [value]="getDisplayValue(orderLine, 'realSellingPrice')"
                          (input)="onDecimalInputChange(orderLine, 'realSellingPrice', $event)"
                          (blur)="onInputBlur(orderLine, 'realSellingPrice')"
                          [class]="((orderLine.realSellingPrice ?? orderLine.product?.price ?? 0) < (orderLine.realPurchasePrice ?? orderLine.product?.purchasePrice ?? 0)) ? 'w-full h-10 px-3 pr-12 text-sm font-medium border-0 bg-red-50 rounded-lg focus:bg-white focus:ring-2 focus:ring-red-500 outline-none transition-all duration-200' : 'w-full h-10 px-3 pr-12 text-sm font-medium border-0 bg-gray-50 rounded-lg focus:bg-white focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200'"
                          placeholder="0.00" (mouseenter)="showTooltip($event, getPurchasePriceTooltip(orderLine))"
                          (mouseleave)="hideTooltip()" />
                        <span class="absolute right-3 text-xs font-medium text-gray-500">
                          MAD
                        </span>
                      </div>
                    </div>

                    <!-- Quantity Control -->
                    <div>
                      <label
                        class="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2">Quantité</label>
                      <div class="flex items-center bg-white border border-gray-200 rounded-lg overflow-hidden">
                        <button (click)="adjustQuantity(orderLine, -1)" [disabled]="orderLine.quantity <= 0"
                          class="w-10 h-10 flex items-center justify-center hover:bg-blue-50 hover:text-blue-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200">
                          <i class="fa fa-minus"></i>
                        </button>
                        <div class="flex-1 h-10 flex items-center justify-center bg-gray-50">
                          <input type="text" autocomplete="off" [value]="getDisplayValue(orderLine, 'quantity')"
                            (input)="onDecimalInputChange(orderLine, 'quantity', $event)"
                            (blur)="onInputBlur(orderLine, 'quantity')"
                            class="w-full h-full text-center font-bold text-gray-900 bg-transparent border-0 outline-none text-sm"
                            placeholder="0.000" />
                        </div>
                        <button (click)="adjustQuantity(orderLine, 1)"
                          [disabled]="orderLine.quantity >= (orderLine.product?.quantity ?? 999999)"
                          class="w-10 h-10 flex items-center justify-center hover:bg-blue-50 hover:text-blue-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>

                    <!-- Total Display -->
                    <div>
                      <label
                        class="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2">Total</label>
                      <div class="h-10 flex items-center bg-green-50 border border-green-200 rounded-lg px-3">
                        <span class="text-lg font-bold text-green-700">
                          {{ getLineTotal(orderLine) | number:'1.2-2' }} MAD
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #emptyOrderState>
              <div class="bg-white rounded-xl border border-gray-100 p-12 text-center shadow-sm">
                <div class="flex items-center justify-center mx-auto mb-4">
                  <i class="fa fa-box-open text-5xl text-gray-300"></i>
                </div>
                <h3 class="text-lg font-medium text-gray-900 mb-2">Aucun produit ajouté</h3>
                <p class="text-gray-500 text-sm max-w-sm mx-auto">
                  Recherchez et ajoutez des produits pour créer votre commande.
                </p>
              </div>
            </ng-template>
          </div>
        </div>

        <!-- Order Summary Sidebar -->
        <div class="w-full min-w-0 xl:col-span-3 2xl:col-span-3 xl:min-w-[420px]">
          <div
            class="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden sticky top-6 w-full max-w-full">
            <!-- Header -->
            <div class="bg-gradient-to-r from-blue-500 to-blue-600 p-4">
              <div class="flex items-center justify-between">
                <h2 class="text-lg font-semibold text-white leading-none">Résumé de la Commande</h2>
                <div class="flex items-center gap-2 text-blue-100">
                  <i class="fa fa-user text-xs"></i>
                  <span class="text-xs font-medium leading-none">{{ client?.firstName }} {{ client?.lastName || 'Aucun
                    client sélectionné' }}</span>
                </div>
              </div>
            </div>

            <div class="p-4">
              <!-- Order Totals - Simplified Request -->
              <div class="space-y-1.5 mb-6">
                <!-- Base Part -->
                <div class="flex justify-between items-center text-gray-600 text-sm">
                  <span>Sous-total:</span>
                  <span class="font-medium text-gray-700">MAD {{ getInitialGrossTotal() | number:'1.2-2' }}</span>
                </div>

                <div class="flex justify-between items-center text-gray-600 text-sm">
                  <span>Réduction:</span>
                  <span class="font-medium text-red-600">-MAD {{ newOrder.discount | number:'1.2-2' }}</span>
                </div>

                <!-- Avoirs (Visible only if has returns) -->
                <div class="flex justify-between items-center text-red-500 text-sm" *ngIf="newOrder.hasReturns">
                  <span>Avoirs:</span>
                  <span class="font-medium">-MAD {{ getAvoirTotal() | number:'1.2-2' }}</span>
                </div>

                <div class="flex justify-between items-center text-gray-600 text-sm" *ngIf="!newOrder.isOrderPaid() && (newOrder.advancePayment || 0) > 0">
                  <span>Avance:</span>
                  <span class="font-medium text-gray-700">MAD {{ newOrder.advancePayment | number:'1.2-2' }}</span>
                </div>

                <div class="h-px bg-gray-200 my-2"></div>

                <div class="flex justify-between items-center">
                  <span class="text-base font-semibold text-gray-900">Total {{ newOrder.hasReturns ? 'Rectifié' : '' }}:</span>
                  <span class="text-base font-bold text-blue-600">
                    MAD {{ getInitialGrossTotal() - (newOrder.discount || 0) - getAvoirTotal() | number:'1.2-2' }}
                  </span>
                </div>

                <!-- Reste à payer -->
                <div class="flex justify-between items-center pt-2 mt-2 border-t border-dashed border-gray-300 bg-red-50 px-2 rounded" *ngIf="!newOrder.isOrderPaid()">
                  <span class="text-lg font-bold text-red-700">Reste à payer:</span>
                  <span class="text-lg font-black text-red-800">
                    MAD {{ (getInitialGrossTotal() - (newOrder.discount || 0) - getAvoirTotal()) - (newOrder.advancePayment || 0) | number:'1.2-2' }}
                  </span>
                </div>
              </div>

              <!-- Payment Status -->
              <div class="mb-6">
                <div class="bg-gray-50 rounded-xl p-2">
                  <div class="flex items-center justify-between">
                    <div class="flex items-center gap-2">
                      <div class="w-8 h-8 rounded-full flex items-center justify-center"
                        [class]="newOrder.isPaid ? 'bg-green-100' : 'bg-gray-200'">
                        <i class="fa fa-credit-card text-sm"
                          [class]="newOrder.isPaid ? 'text-green-600' : 'text-gray-500'"></i>
                      </div>
                      <div>
                        <p class="font-medium text-gray-900 text-sm -mb-1 margin-bottom-8px">Statut de Paiement</p>
                        <p [class]="newOrder.isPaid ? 'text-green-600' : 'text-gray-500'" class="text-xs">
                          {{ newOrder.isPaid ? 'Payé' : 'En attente' }}
                        </p>
                      </div>
                    </div>
                    <label class="toggle-switch">
                      <input type="checkbox" [(ngModel)]="newOrder.isPaid" />
                      <span class="toggle-slider"></span>
                    </label>
                  </div>
                </div>
              </div>

              <!-- Virtual Order (F8 Rush Mode) -->
              <div class="mb-6">
                <div class="bg-amber-50 rounded-xl p-2 border border-amber-200">
                  <div class="flex items-center justify-between">
                    <div class="flex items-center gap-2">
                      <div class="w-8 h-8 rounded-full flex items-center justify-center"
                        [class]="newOrder.isVirtual ? 'bg-amber-100' : 'bg-gray-200'">
                        <i class="fa fa-bolt text-sm"
                          [class]="newOrder.isVirtual ? 'text-amber-600' : 'text-gray-500'"></i>
                      </div>
                      <div>
                        <p class="font-medium text-gray-900 text-sm -mb-1 margin-bottom-8px">Commande Virtuelle</p>
                        <p [class]="newOrder.isVirtual ? 'text-amber-600' : 'text-gray-500'" class="text-xs">
                          <!-- Mode UPDATE d'une commande virtuelle : Toujours montrer le budget disponible -->
                          <span *ngIf="newOrder.isVirtual && orderId">
                            Budget : {{ effectiveDisplayBalance | number:'1.2-2' }} MAD
                          </span>
                          <!-- Mode CREATE : Vérifier qu'il y a des F8 disponibles -->
                          <span *ngIf="!orderId && unconfirmedF8Count > 0 && solvencyGap <= 0">
                            {{ newOrder.isVirtual ? 'Argent déjà encaissé (F8)' : 'Disponible : ' +
                            (effectiveDisplayBalance | number:'1.2-2') + ' MAD' }}
                          </span>
                          <span *ngIf="!orderId && unconfirmedF8Count <= 0" class="text-red-500">
                            Aucun F8 disponible
                          </span>
                          <span *ngIf="!orderId && unconfirmedF8Count > 0 && solvencyGap > 0" class="text-red-500">
                            Insuffisant (Manque {{ solvencyGap | number:'1.2-2' }} DH)
                          </span>
                        </p>
                      </div>
                    </div>
                    <label class="toggle-switch">
                      <input type="checkbox" [(ngModel)]="newOrder.isVirtual" [disabled]="!canBeVirtual && !orderId" />
                      <span class="toggle-slider toggle-slider-amber"></span>
                    </label>
                  </div>
                </div>
              </div>



              <!-- Discount -->
              <div class="mb-6">
                <label class="block text-sm font-medium text-gray-700 mb-2">Réduction</label>
                <div class="relative">
                  <input type="number" autocomplete="off" [(ngModel)]="newOrder.discount" [disabled]="isDiscountDisabled" min="0"
                    [attr.max]="newOrder.total || null" step="0.01"
                    class="w-full h-11 px-4 pr-12 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all duration-200 disabled:bg-gray-50 disabled:text-gray-500"
                    placeholder="Entrez le montant de la réduction" />
                  <span class="absolute right-4 top-1/2 transform -translate-y-1/2 text-sm text-gray-500">
                    MAD
                  </span>
                </div>
              </div>

              <!-- Advance Payment -->
              <div class="mb-6">
                <label class="block text-sm font-medium text-gray-700 mb-2">Paiement d'Avance</label>
                <div class="relative">
                  <input type="text" autocomplete="off" [(ngModel)]="newOrder.advancePayment"
                    class="w-full h-11 px-4 pr-12 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all duration-200"
                    placeholder="Entrez le montant d'avance" />
                  <span class="absolute right-4 top-1/2 transform -translate-y-1/2 text-sm text-gray-500">
                    MAD
                  </span>
                </div>
              </div>

              <!-- Order Notes -->
              <div class="mb-6">
                <label class="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                  <i class="fa fa-file-text"></i>
                  Notes de Commande
                </label>
                <textarea [(ngModel)]="newOrder.notes" rows="4"
                  class="w-full p-4 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all duration-200 resize-none"
                  placeholder="Ajoutez des instructions spéciales ou des notes..."
                  (keydown)="onTextareaKeydown($event)"></textarea>
                <p class="text-xs text-gray-500 mt-2">
                  Ces notes apparaîtront sur le reçu et pour référence interne.
                </p>
              </div>

              <!-- Action Buttons -->
              <div class="space-y-3 mb-6">
                <button type="button" [disabled]="!newOrder.orderLines?.length"
                  (click)="url === '/updateOrder' ? updateOrderAndReset() : addOrderAndReset()"
                  class="w-full h-12 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-purple-700 disabled:from-gray-300 disabled:to-gray-300 disabled:cursor-not-allowed transition-all duration-200 flex items-center justify-center gap-2">
                  <i class="fa fa-credit-card"></i>
                  {{ url === '/updateOrder' ? 'Modifier la Commande' : 'Créer la Commande' }}
                </button>
                <button type="button"
                  class="w-full h-11 border border-gray-200 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors duration-200">
                  Enregistrer comme Brouillon
                </button>
              </div>
            </div>

            <!-- Footer Stats -->
            <div class="bg-gray-50 p-4 border-t border-gray-100">
              <div class="grid grid-cols-3 gap-4 text-center">
                <div>
                  <div class="text-xl font-bold text-blue-600">{{ newOrder.orderLines ? newOrder.orderLines.length : 0
                    }}</div>
                  <div class="text-xs text-gray-600">Articles</div>
                </div>
                <div>
                  <div class="text-xl font-bold text-green-600">{{ getTotalQuantity() }}</div>
                  <div class="text-xs text-gray-600">Quantité</div>
                </div>
                <div>
                  <div class="text-xl font-bold text-purple-600">
                    {{ (((newOrder.total || 0) - (newOrder.discount || 0)) / 1000) | number:'1.1-1' }}K
                  </div>
                  <div class="text-xs text-gray-600">MAD</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Tooltip -->
<div *ngIf="tooltipVisible"
  class="fixed z-50 px-3 py-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg pointer-events-none"
  [style.left.px]="tooltipX" [style.top.px]="tooltipY">
  {{ tooltipText }}
</div>